import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import { getClonesAsync, getTrandingClonesAsync } from "./actions";
import { ClonesState } from "./slice";

type ActionReducerMapBuilderWithClonesState =
  ActionReducerMapBuilder<ClonesState>;

export const getClonesReducer = (
  builder: ActionReducerMapBuilderWithClonesState
) => {
  builder.addCase(getClonesAsync.pending, (state) => {
    state.clones.isLoading = true;
  });

  builder.addCase(
    getClonesAsync.fulfilled,
    (state, actions: PayloadAction<IResponseWithPagination<IClone>>) => {
      state.clones.isLoading = false;
      state.clones.data = actions.payload;
    }
  );

  builder.addCase(getClonesAsync.rejected, (state) => {
    state.clones.isLoading = false;
    state.clones.data = null;
  });
};

export const getTrandingClonesReducer = (
  builder: ActionReducerMapBuilderWithClonesState
) => {
  builder.addCase(getTrandingClonesAsync.pending, (state) => {
    state.trandingClones.isLoading = true;
  });

  builder.addCase(
    getTrandingClonesAsync.fulfilled,
    (state, actions: PayloadAction<IResponseWithPagination<IClone>>) => {
      state.trandingClones.isLoading = false;
      state.trandingClones.data = actions.payload;
    }
  );

  builder.addCase(getTrandingClonesAsync.rejected, (state) => {
    state.trandingClones.isLoading = false;
    state.trandingClones.data = null;
  });
};
